import '../polyfills.ts';
import { OrderByPipe } from './pipes/orderby.pipe';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  MatNativeDateModule,
  NativeDateAdapter,
  DateAdapter,
  MatButtonModule,
  MatInputModule,
  MatSelectModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  MatDatepickerModule
} from '@angular/material';
import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule } from 'devextreme-angular';
import { ModelDetailsComponent } from './product-category/containers/model-details/model-details.component';
import { ProductTypeDetailsComponent } from './product-category/containers/product-type-details/product-type-details.component';
import { BrowserModule } from '@angular/platform-browser';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {ApplicationRef, NgModule} from '@angular/core';
import {ProductCategoryModule} from './product-category/product-category.module';
import {ProductCatContainerComponent} from './product-category/containers/product-cat.container.component';
import {CarouselComponent} from './product-category/containers/carousel/carousel.component';
import {AppComponent} from './app.component';
import { SwiperModule } from 'angular2-useful-swiper';
import { AuthService } from './auth/auth.service';
import { AccessoryDetailsComponent } from './product-category/containers/accessory-details/accessory-details.component';
import { ProductImageUploadComponent } from './image-admin/product-image-upload.component';
import { ResourceMappingComponent } from './resource-mapping/resource-mapping.component';
import { MomentDateAdapter } from './date-adapter/moment-date-adapter.class';
import { MOMENT_DATE_FORMATS } from './date-formats/moment-date-formats';
import { SearchResultComponent } from './search-results/search-result.component';
import { LocatorComponent  } from './product-category/components/locator/locator.component';
import {ResourcesContainerComponent} from './resources/containers/resources-container.component';
import {ResourcesModule} from './resources/resources.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DealerSignUpModule} from './dealer-sign-up/dealer-sign-up.module';
import {DealerSignUpModalComponent} from './dealer-sign-up/containers/dealer-sign-up-modal.component';
import { DistributorProfileComponent } from './distributor/containers/distributor-profile/distributor-profile.component';
import { DistributorModule } from './distributor/distributor.module';
import { DistributorComponent } from './distributor/distributor.component';
import { DealerProfileComponent } from './distributor/containers/dealer-profile/dealer-profile.component';
import { DealerViewComponent } from './distributor/containers/dealer-view/dealer-view.component';
import { EmployeeProfileComponent } from './distributor/containers/employee-profile/employee-profile.component';
import { RouterModule } from '@angular/router';
const FEATURE_MODULES = [DistributorModule];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    ProductCategoryModule,
    HttpClientModule,
    DealerSignUpModule,
    ResourcesModule,
    SwiperModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatIconModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ...FEATURE_MODULES
  ],
  providers: [AuthService, OrderByPipe,
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }],
  entryComponents: [CarouselComponent, ProductCatContainerComponent, AppComponent, ProductTypeDetailsComponent,
    ModelDetailsComponent, AccessoryDetailsComponent, ProductImageUploadComponent, ResourceMappingComponent,
    SearchResultComponent, LocatorComponent, ResourcesContainerComponent, DealerSignUpModalComponent,
    DistributorComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,],
})
export class AppModule {

  ngDoBootstrap(appRef: ApplicationRef) {
    console.log('ngDoBootstrap running');
    const widgets = document.querySelectorAll('[start-module]');
    for (const i in widgets) {
      if (widgets.hasOwnProperty(i)) {
        this.bootstrapRootComponent(appRef, widgets[i].localName);
      }
    }
  }

  bootstrapRootComponent(app, name) {
    // define the possible bootstrap components
    // with their selectors (html host elements)
    const options = {
      'app-root': AppComponent,
      'app-carousel': CarouselComponent,
      'app-product-category': ProductCatContainerComponent,
      'app-product-type-details': ProductTypeDetailsComponent,
      'app-model-details': ModelDetailsComponent,
      'app-accessory-details': AccessoryDetailsComponent,
      'app-product-image-upload': ProductImageUploadComponent,
      'app-resource-mapping': ResourceMappingComponent,
      'app-resources': ResourcesContainerComponent,
      'app-search-results': SearchResultComponent,
      'app-professional-locator': LocatorComponent,
      'app-dealer-sign-up-modal': DealerSignUpModalComponent,
      'app-distributor': DistributorComponent,
      'app-distributor-profile': DistributorProfileComponent,
      'app-dealer-view': DealerViewComponent,
      'app-dealer-profile': DealerProfileComponent,
      'app-employee-profile': EmployeeProfileComponent
    };

    // create DOM element for the component being bootstrapped
    // and add it to the DOM
    const componentElement = document.createElement(name);
    document.body.appendChild(componentElement);
    // bootstrap the application with the selected component
    const component = options[name];
    app.bootstrap(component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts